/* Boosted Engineering easter eggs, part 2:
   1. Phones: hold the logo for 1.5 seconds → BOOST MODE dyno pull (same as the Konami code).
   2. Secret searches ("send it", "1000hp", "full boost", ...) → turbo kits, with anti-lag pops.
   3. Cart over $5,000 → "Big turbo energy" with anti-lag pops (once per session).
   4. Toggle Day/Night 5 times quickly → headlights flash on the "Shop popular vehicles" tiles. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var POPS = 'https://cdn.shopify.com/s/files/1/0729/7541/7574/files/be-antilag-pops.mp3?v=1792221890';
  var BIG_CART = 500000; /* cents */

  var play = function (src, vol, from, to) {
    try {
      var a = new Audio(src);
      a.volume = vol || 0.7;
      if (from) { a.currentTime = from; }
      var p = a.play();
      if (p && p.catch) { p.catch(function () {}); }
      if (to) { setTimeout(function () { try { a.pause(); } catch (e) {} }, (to - (from || 0)) * 1000); }
      return a;
    } catch (e) { return null; }
  };

  /* Small toast card, reusing the .be-egg overlay styles */
  var toast = function (title, text, href, label, ms) {
    var old = document.querySelector('.be-egg');
    if (old) { old.remove(); }
    var wrap = document.createElement('div');
    wrap.className = 'be-egg be-egg--toast';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-label', title);
    var card = document.createElement('div');
    card.className = 'be-egg__card';
    var x = document.createElement('button');
    x.type = 'button'; x.className = 'be-egg__x'; x.setAttribute('aria-label', 'Close'); x.textContent = '×';
    card.appendChild(x);
    var flames = document.createElement('div');
    flames.className = 'be-egg__flames';
    flames.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 2; i++) { var f = document.createElement('span'); flames.appendChild(f); }
    card.appendChild(flames);
    var h = document.createElement('div'); h.className = 'be-egg__title'; h.textContent = title; card.appendChild(h);
    if (text) { var p = document.createElement('div'); p.className = 'be-egg__cap be-egg__cap--plain'; p.textContent = text; card.appendChild(p); }
    if (href) { var a = document.createElement('a'); a.className = 'be-btn be-btn--red be-egg__cta'; a.href = href; a.textContent = label; card.appendChild(a); }
    wrap.appendChild(card);
    document.body.appendChild(wrap);
    requestAnimationFrame(function () { wrap.classList.add('is-in'); });
    var t;
    var close = function () { clearTimeout(t); wrap.classList.remove('is-in'); setTimeout(function () { wrap.remove(); }, 300); document.removeEventListener('keydown', onKey); };
    var onKey = function (e) { if (e.key === 'Escape') { close(); } };
    document.addEventListener('keydown', onKey);
    x.addEventListener('click', close);
    wrap.addEventListener('click', function (e) { if (e.target === wrap) { close(); } });
    t = setTimeout(close, ms || 6000);
    return close;
  };

  /* ---------- 1. Long-press the logo (phones) → dyno pull ---------- */
  var fireKonami = function () {
    ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'].forEach(function (k) {
      document.dispatchEvent(new KeyboardEvent('keydown', { key: k, bubbles: true }));
    });
  };
  var logo = document.querySelector('.be-logo');
  if (logo) {
    var held = null, fired = false;
    logo.addEventListener('touchstart', function () {
      fired = false;
      clearTimeout(held);
      held = setTimeout(function () {
        fired = true;
        if (navigator.vibrate) { try { navigator.vibrate([30, 40, 30, 40, 80]); } catch (e) {} }
        fireKonami();
      }, 1500);
    }, { passive: true });
    var cancel = function () { clearTimeout(held); };
    logo.addEventListener('touchmove', cancel, { passive: true });
    logo.addEventListener('touchcancel', cancel, { passive: true });
    logo.addEventListener('touchend', function (e) {
      clearTimeout(held);
      if (fired) { e.preventDefault(); e.stopPropagation(); }
    });
    logo.addEventListener('contextmenu', function (e) { if (fired) { e.preventDefault(); } });
    logo.style.webkitTouchCallout = 'none';
  }

  /* ---------- 2. Secret search terms ---------- */
  var SECRETS = {
    'send it': 'Full send detected.',
    'full send': 'Full send detected.',
    '1000hp': 'Four figures? Respect.',
    '1000 hp': 'Four figures? Respect.',
    'full boost': 'Wastegate shut. Let’s go.',
    'more power': 'You came to the right place.',
    '2 step': 'Launch control armed.',
    '2step': 'Launch control armed.',
    'anti lag': 'Pops and bangs, coming right up.',
    'antilag': 'Pops and bangs, coming right up.'
  };
  var secretFor = function (q) {
    q = (q || '').toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();
    return Object.prototype.hasOwnProperty.call(SECRETS, q) ? SECRETS[q] : null;
  };
  var secretHit = function (line) {
    play(POPS, 0.7);
    toast('BOOST MODE', line, '/collections/turbo-kits', 'Shop turbo kits', 9000);
  };
  var sInput = document.querySelector('[data-be-search-input]');
  if (sInput) {
    sInput.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') { return; }
      var line = secretFor(sInput.value);
      if (!line) { return; }
      e.preventDefault();
      e.stopImmediatePropagation();
      sInput.blur();
      secretHit(line);
    }, true);
  }
  try {
    if (/^\/search/.test(location.pathname)) {
      var q0 = new URLSearchParams(location.search).get('q');
      var l0 = secretFor(q0);
      if (l0) { setTimeout(function () { secretHit(l0); }, 400); }
    }
  } catch (e) {}

  /* ---------- 3. Big cart (over $5,000) ---------- */
  var bigCartShown = function () { try { return sessionStorage.getItem('be-bigcart') === '1'; } catch (e) { return false; } };
  var checkCart = function (fromAdd) {
    if (bigCartShown()) { return; }
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      if (!c || c.total_price < BIG_CART) { return; }
      if (!fromAdd && !/^\/cart/.test(location.pathname)) { return; }
      try { sessionStorage.setItem('be-bigcart', '1'); } catch (e) {}
      play(POPS, 0.75);
      toast('BIG TURBO ENERGY', 'Your cart just went full boost. Need a hand with fitment? We’re here.', '/pages/contact', 'Talk to the team', 8000);
    }).catch(function () {});
  };
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (r) { if (r && r.ok) { setTimeout(function () { checkCart(true); }, 300); } }).catch(function () {});
      }
      return p;
    };
  }
  if (/^\/cart/.test(location.pathname)) { checkCart(false); }

  /* ---------- 4. Day/Night ×5 → headlights on the vehicle tiles ---------- */
  /* Light positions are measured on each tile photo at the desktop 16:10 crop: [x%, y%] per lamp. */
  var LAMPS = {
    'JDPA_2022_Toyota_GR_86': { c: 'red', p: [[12.3, 44.5], [36.6, 44.5]] },
    'images_1': { c: 'white', p: [[46.2, 49.4], [80.0, 40.3]] },
    'DSC01437': { c: 'white', p: [[48.8, 48.6], [70.8, 47.8]] },
    'Gemini_Generated_Image_mx7z2qmx7z2qmx7z': { c: 'white', p: [[6.0, 54.0], [34.9, 58.9]] },
    'BMW-F82-M4-FSeries_Parts': { c: 'white', p: [[8.9, 52.8], [51.7, 52.8]] },
    'P90624616': { c: 'white', p: [[61.8, 58.9], [83.3, 56.4]] }
  };
  var lampFor = function (img) {
    var src = (img && (img.currentSrc || img.src)) || '';
    for (var k in LAMPS) { if (Object.prototype.hasOwnProperty.call(LAMPS, k) && src.indexOf(k) !== -1) { return LAMPS[k]; } }
    return null;
  };
  /* Convert a point measured on the 16:10 crop into the tile's current crop (object-fit: cover, centred). */
  var mapPoint = function (px, py, img, tw, th) {
    var iw = img.naturalWidth || 16, ih = img.naturalHeight || 10;
    var rh = tw * 10 / 16;
    var s1 = Math.max(tw / iw, rh / ih);
    var ix = (px / 100 * tw - (tw - iw * s1) / 2) / s1;
    var iy = (py / 100 * rh - (rh - ih * s1) / 2) / s1;
    var s2 = Math.max(tw / iw, th / ih);
    return [ix * s2 + (tw - iw * s2) / 2, iy * s2 + (th - ih * s2) / 2];
  };
  var flashTiles = function () {
    var tiles = Array.prototype.slice.call(document.querySelectorAll('.be-vt__tile'));
    if (!tiles.length) { return false; }
    var grid = document.querySelector('.be-vt');
    if (grid) { grid.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }
    setTimeout(function () {
      tiles.forEach(function (tile, i) {
        var img = tile.querySelector('.be-vt__img');
        var cfg = lampFor(img);
        var r = tile.getBoundingClientRect();
        var layer = document.createElement('span');
        layer.className = 'be-lamps' + (cfg ? ' is-' + cfg.c : ' is-sweep');
        layer.setAttribute('aria-hidden', 'true');
        layer.style.animationDelay = (i * 90) + 'ms';
        if (cfg && img) {
          cfg.p.forEach(function (pt) {
            var m = mapPoint(pt[0], pt[1], img, r.width, r.height);
            var l = document.createElement('i');
            l.style.left = m[0] + 'px';
            l.style.top = m[1] + 'px';
            l.style.animationDelay = (i * 90) + 'ms';
            layer.appendChild(l);
          });
        }
        tile.appendChild(layer);
        setTimeout(function () { layer.remove(); }, 2600 + i * 90);
      });
    }, reduce ? 0 : 450);
    return true;
  };
  var themeBtn = document.querySelector('[data-be-theme]');
  if (themeBtn) {
    var taps = [];
    themeBtn.addEventListener('click', function () {
      var now = Date.now();
      taps = taps.filter(function (t) { return now - t < 4000; });
      taps.push(now);
      if (taps.length >= 5) {
        taps = [];
        if (!flashTiles()) {
          toast('HIGH BEAMS ON', 'Head to the home page and try that again.', '/', 'Go home', 5000);
        }
      }
    });
  }
})();
